import { getToken } from './accessToken.js';
import { getItem, SESSION_STORAGE } from '@analytics/storage-utils';

const requestSuccessCallbackV3 = function (config) {
    // Do something before request is sent
    let customConfig = Object.assign({}, config);
    const sessionId = getItem("peek__session_id", { storage: SESSION_STORAGE });
    if (sessionId) {
        customConfig = Object.assign(Object.assign({}, config), { headers: Object.assign(Object.assign({}, config.headers), { "X-Amzn-Trace-Id": `PeekSessionId=${sessionId}` }) });
    }
    const token = getToken();
    if (token) {
        customConfig = Object.assign(Object.assign({}, config), { headers: Object.assign({ Authorization: `Bearer ${token}` }, customConfig.headers) });
    }
    return customConfig;
};
const responseSuccessCallbackV3 = function (config) {
    return config.data;
};
const responseFailCallbackV3 = function (error) {
    var _a, _b, _c, _d, _e, _f, _g;
    // Do something with request error
    const { message = (_e = (_d = (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : error === null || error === void 0 ? void 0 : error.message) !== null && _e !== void 0 ? _e : "We are facing an issue. Please try again later.", payload, response_code, } = ((_f = error === null || error === void 0 ? void 0 : error.response) === null || _f === void 0 ? void 0 : _f.data) || {};
    return Promise.reject(new Error(message, {
        cause: {
            //@ts-ignore
            code: response_code || ((_g = error === null || error === void 0 ? void 0 : error.response) === null || _g === void 0 ? void 0 : _g.status),
            data: payload,
        },
    }));
};

export { requestSuccessCallbackV3, responseFailCallbackV3, responseSuccessCallbackV3 };
